module.exports = __webpack_public_path__ + "static/media/huiyuan_cover.255661f7.png";